// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2AJd4","title":"Images45_title__2z3lj","images":"Images45_images__1xzkJ"};